export default [
  {
    path: '/mobile/announce/list',
    name: 'mobile-announce-list',
    component: () => import('@/views/mobile/announce/AnnounceList.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '资讯公告',
    },
  },
  {
    path: '/mobile/announce/subscribe-setting',
    name: 'mobile-announce-subscribe-setting',
    component: () => import('@/views/mobile/announce/SubscribeSetting.vue'),
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '资讯公告订阅设置',
    },
  },
  {
    path: '/mobile/announce/review/:id',
    name: 'mobile-announce-review',
    component: () =>
      import('@/views/admin/main/components/announce/Review.vue'), // 该组件同时适用于移动端和非移动端多套路由地址
    meta: {
      layout: 'mobile',
      notNeedProgress: true,
      title: '资讯公告详情',
    },
  },
];
